import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

export const nayaxApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getNayaxTrackings: build.query({
      query: (args) => {
        if (args) {
          const { page, perPage, searchQuery = '', dateRange, ...otherFilters } = args;

          const params = new URLSearchParams();

          const pageNum = Number(page) || DEFAULT_PAGE;
          const perPageNum = Number(perPage) || DEFAULT_PER_PAGE;

          params.append('page', pageNum.toString());
          params.append('perPage', perPageNum.toString());

          if (searchQuery && searchQuery.trim()) {
            params.append('q', searchQuery.trim());
          }

          if (dateRange?.from) {
            params.append('submittedDateFrom', dateRange.from);
          }
          if (dateRange?.to) {
            params.append('submittedDateTo', dateRange.to);
          }

          Object.keys(otherFilters).forEach((key) => {
            if (otherFilters[key] !== undefined && otherFilters[key] !== null && otherFilters[key] !== '') {
              params.append(key, otherFilters[key]);
            }
          });

          const finalUrl = `${apiUrl.nayax}?${params.toString()}`;
          return finalUrl;
        }
        return `${apiUrl.nayax}`;
      },
      serializeQueryArgs: ({ queryArgs }) => {
        const { page, perPage, searchQuery = '', dateRange, ...otherFilters } = queryArgs || {};

        const cacheKey = {
          page: Number(page) || DEFAULT_PAGE,
          perPage: Number(perPage) || DEFAULT_PER_PAGE,
          searchQuery: searchQuery.trim(),
          dateRange,
          ...otherFilters,
        };

        return JSON.stringify(cacheKey);
      },
      providesTags: ['Nayax'],
    }),

    uploadNayaxCsv: build.mutation({
      query: (files) => {
        const formData = new FormData();

        if (Array.isArray(files)) {
          files.forEach((file) => {
            formData.append('csv_file', file);
          });
        } else {
          formData.append('csv_file', files);
        }

        return {
          url: `${apiUrl.nayax}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Nayax'],
    }),

    getNayaxTrackingById: build.query({
      query: (id) => `${apiUrl.nayax}/${id}`,
      providesTags: ['Nayax'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetNayaxTrackingsQuery,
  useLazyGetNayaxTrackingsQuery,
  useUploadNayaxCsvMutation,
  useGetNayaxTrackingByIdQuery,
  useLazyGetNayaxTrackingByIdQuery,
} = nayaxApi;
